'use client'

import React from 'react'
import { useSoloViewer } from './provider'
import { ImageSoloViewer } from './image-solo-viewer'
import { TokenSoloViewer } from './token-solo-viewer'

export const SoloViewer = (): React.ReactElement => {
  const { soloViewerData } = useSoloViewer()
  const { token, image } = soloViewerData

  if (token) {
    return <TokenSoloViewer />
  } else if (image) {
    return <ImageSoloViewer />
  }

  return <></>
}
